export const CLOUD_STOAGE = {
    PROFILE_IMAGES: "/Profile_Images",
}